import { render, staticRenderFns } from "./LinkPacientePerfilBandejaEspecialidadComponente.vue?vue&type=template&id=57da5d7b"
import script from "./LinkPacientePerfilBandejaEspecialidadComponente.vue?vue&type=script&lang=js"
export * from "./LinkPacientePerfilBandejaEspecialidadComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports